import { Box, useTheme } from '@mui/material'
import React from 'react'

interface CardProps {
  children: React.ReactNode
}

const Card: React.FC<CardProps> = ({ children }) => {
  const theme = useTheme()
  return (
    <Box
      bgcolor={theme.palette.background.paper}
      p={2}
      display="flex"
      flexDirection="column"
      gap="16px"
    >
      {children}
    </Box>
  )
}

export default Card
